/**
 * @typedef {import('./types').ModalTrapActivateEvent} ModalTrapActivateEvent
 * @typedef {import('./types').ModalTrapDeactivateEvent} ModalTrapDeactivateEvent
 * @typedef {import('./types').CartForm} CartForm
 */

if (!customElements.get('cart-tray')) {
  customElements.define(
    'cart-tray',
    class CartTray extends HTMLElement {
      constructor() {
        super();
        this.handleModalTrapActivate = this.handleModalTrapActivate.bind(this);
        this.handleModalTrapDeactivate = this.handleModalTrapDeactivate.bind(this);
        this.handleHashChange = this.handleHashChange.bind(this);
      }

      async handleModalTrapActivate(/** @type {ModalTrapActivateEvent} */ e) {
        /** @type {CartForm | null} */
        const cart = this.querySelector('cart-form');

        if (e.detail.id === 'cart-tray' && cart) {
          cart.reloadSection();
        }
      }

      handleModalTrapDeactivate(/** @type {ModalTrapDeactivateEvent} */ e) {
        if (e.detail.id === 'cart-tray' && location.hash === '#cart') {
          history.replaceState(null, '', `${location.pathname}${location.search}`);
        }
      }

      openFromHash() {
        if (location.pathname.startsWith('/account')) return;

        const params = new URLSearchParams(location.search);
        const openFromQuery = params.get('open_cart') === '1';
        const openFromHash = location.hash === '#cart';

        if (!openFromQuery && !openFromHash) return;

        const cartTray = window.traps.store['cart-tray'];

        if (cartTray && !cartTray.active) {
          window.traps.deactivate();
          cartTray.activate();
        }

        if (openFromQuery) {
          params.delete('open_cart');
          const search = params.toString();

          history.replaceState(null, '', `${location.pathname}${search ? `?${search}` : ''}#cart`);
        }
      }

      handleHashChange() {
        this.openFromHash();
      }

      connectedCallback() {
        window.addEventListener('modal-trap-activate', this.handleModalTrapActivate);
        window.addEventListener('modal-trap-deactivate', this.handleModalTrapDeactivate);
        window.addEventListener('hashchange', this.handleHashChange);
        this.openFromHash();
      }

      disconnectedCallback() {
        window.removeEventListener('modal-trap-activate', this.handleModalTrapActivate);
        window.removeEventListener('modal-trap-deactivate', this.handleModalTrapDeactivate);
        window.removeEventListener('hashchange', this.handleHashChange);
      }
    },
  );
}
